/**
 * briefReport模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const briefReport = {
  // 查询邮件模板
  selectTemplate(params) {
    return $http.post(`${global.API_URL}/sme/briefReport/select`,params);
  },
  // 查询邮件模板
  selectByModuleIndex(params) {
    return $http.post(`${global.API_URL}/sme/briefReport/selectByModuleIndex`,params);
  }
}

export default briefReport;



// WEBPACK FOOTER //
// ./src/api/briefReport.js